"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const is_empty_1 = __importDefault(require("../../utils/is-empty"));
const message_defaults_json_1 = __importDefault(require("../../message-defaults.json"));
const messageDefault = message_defaults_json_1.default.phone;
const validationBuilder = (message, { existingNumbers, initialValue } = { existingNumbers: undefined, initialValue: undefined }) => {
    const getMessage = (key) => lodash_1.default.get(message, key, messageDefault[key]);
    return (value) => {
        if (!(0, is_empty_1.default)(value)) {
            // Check that the phone number doesn’t include any random characters. Allow numbers like "(+61) 400 111 222"
            if (String(value).match(/[^0-9()+ ]/g)) {
                return getMessage('special');
            }
            // Strip all non digits from phone number
            let transformed = lodash_1.default.replace(String(value), /[^0-9]+/g, '');
            // Format the phone number to replace 61 with 0
            transformed = lodash_1.default.replace(transformed, /^61/, '0');
            const validAreaCodes = ['02', '03', '04', '05', '07', '08'];
            if (!lodash_1.default.includes(validAreaCodes, transformed.substring(0, 2))) {
                return getMessage('areaCode');
            }
            if (transformed.length !== 10) {
                return getMessage('length');
            }
            if (transformed !== initialValue && lodash_1.default.includes(existingNumbers, transformed)) {
                return getMessage('duplicate');
            }
        }
        return null;
    };
};
validationBuilder.messageDefault = messageDefault;
exports.default = validationBuilder;
